import React, { useState } from 'react';
import axios from 'axios';
import { MailCheck } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import AuthLayout, { FormError, TextLink } from '../components/AuthLayout';

import { API } from '../lib/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || "We couldn't send the link. Try again in a moment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title={sent ? 'Check your email' : 'Reset your password'}
      subtitle={sent ? null : "Enter your account email and we'll send you a link to choose a new password."}
      footer={<>Remembered it? <TextLink to="/login">Sign in</TextLink></>}
      backTo="/login"
      backLabel="Back to sign in"
    >
      {sent ? (
        <div className="flex items-start gap-3 rounded-md border border-line bg-surface p-4">
          <MailCheck className="mt-0.5 h-5 w-5 shrink-0 text-sev-low" strokeWidth={1.5} aria-hidden="true" />
          <p className="m-0">
            If an account exists for <b>{email}</b>, a reset link is on its way. It works for one hour.
          </p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
          <FormError>{error}</FormError>
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="forgot-email">Email</Label>
            <Input
              id="forgot-email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              className="h-12"
              required
            />
          </div>
          <Button type="submit" size="lg" disabled={loading} className="mt-1 w-full">
            {loading ? 'Sending…' : 'Send reset link'}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
